export { default } from './useTheme';


//////////////////
// WEBPACK FOOTER
// ../@mui/private-theming/useTheme/index.js
// module id = 759
// module chunks = 22